<script lang="ts" setup>
import { createOtTableColumnInstance } from '@1trading/design-system';
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { PricetickModel } from '@exchange/libs/price-ticks/service/src';

import PriceTicksHistoryItem from './PriceTicksHistoryItem.vue';

const props = defineProps({
  /** Price ticks to show */
  priceTicks: { type: Array as PropType<Array<PricetickModel>>, required: true },
  /** Market id */
  marketId: { type: String, required: true },
  /** Market amount precision */
  amountPrecision: { type: Number, required: true },
  /** Market market precision */
  marketPrecision: { type: Number, required: true },
});

const { t } = useI18n({ useScope: 'global' });

const header = computed(() => [
  createOtTableColumnInstance({
    title: '',
    columnClass: 'text-align-right  price-ticks-history-list__column-cell',
  }),
  createOtTableColumnInstance({
    title: t('modules.marketHistory.header.amount'),
    columnClass: 'text-align-right price-ticks-history-list__column-cell price-ticks-history-list__column-cell--value',
  }),
  createOtTableColumnInstance({
    title: t('modules.marketHistory.header.price'),
    columnClass: 'text-align-right  price-ticks-history-list__column-cell price-ticks-history-list__column-cell--value',
  }),
  createOtTableColumnInstance({
    title: t('modules.marketHistory.header.time'),
    columnClass: 'text-align-right  price-ticks-history-list__column-cell price-ticks-history-list__column-cell--time',
  }),
]);

const showArrow = (index: number) => {
  if (!props.priceTicks[index + 1]) {
    return false;
  }

  const thisTick = props.priceTicks[index];
  const nextTick = props.priceTicks[index + 1];

  return thisTick?.price !== nextTick?.price || thisTick?.takerSide !== nextTick?.takerSide;
};
</script>

<template>
  <ot-table
    :key="marketId"
    :class="['price-ticks-history-list']"
    :header="header"
    :rows="[]"
  >
    <template #default="{ rowClass }">
      <price-ticks-history-item
        v-for="(priceTick, index) in priceTicks"
        :key="priceTick.internalId"
        :class="rowClass"
        :amount-precision="amountPrecision"
        :market-precision="marketPrecision"
        :price-tick="priceTick"
        :show-arrow="showArrow(index)"
      />
    </template>
  </ot-table>
</template>

<style lang="scss">
.price-ticks-history-list {
  &__column-cell--value {
    width: calc(50% - 40px);
  }

  &__column-cell--time {
    padding-right: 10px;
  }
}
</style>
